<!--
 * @Author: zxf
 * @Date: 2022-08-07 21:42:15
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-29 14:34:57
 * @Description: 签到信息
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ pTitle }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <el-button
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        >
          查询
        </el-button>
        <el-button
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        >
          重置
        </el-button>
        <el-button
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        >
          导出
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="统计月份"
                prop="tjyf"
              >
                <el-date-picker
                  v-model="filterParams.tjyf"
                  type="month"
                  value-format="timestamp"
                  placeholder="选择月"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="手机类型"
                prop="sjlx"
              >
                <el-select
                  v-model="filterParams.sjlx"
                  clearable
                  class="c-form__select"
                  style="width: 100%;"
                  placeholder="请选择手机类型"
                >
                  <el-option
                    value="android"
                    label="android"
                  />
                  <el-option
                    value="ios"
                    label="ios"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="ryqdxxTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog('view', scope.row)"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!-- 查看详情 -->
    <qdxx-view-dialog
      v-if="showDialogName==='view'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { qdxxService } from './qdxx.service.js';
import QdxxViewDialog from './viewDialog.vue';
export default {
  name: 'JcryqdIndex',
  components: {
    QdxxViewDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        qdType: null, // 业务类型
        xmmc: null, // 项目名称
        sjlx: null, // 手机类型
        tjyf: new Date().getTime() // 统计月份
      },
      /* 查询条件 end */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '140', type: 'text' },
        { key: 'xmdz', label: '项目地址', align: '', minWidth: '180', type: 'text' },
        { key: 'qdrMc', label: '签到人', align: '', width: '100', type: 'text' },
        { key: 'qdsj', label: '签到时间', align: 'center', width: '130', type: 'dateTime' },
        { key: 'gpsX', label: 'GPS-X坐标', align: 'left', width: '140', type: 'text' },
        { key: 'gpsY', label: 'GPS-Y坐标', align: 'left', width: '140', type: 'text' },
        { key: 'qddz', label: '签到地址', align: 'left', minWidth: '150', type: 'text' },
        { key: 'sjlx', label: '手机类型', align: 'left', width: '80', type: 'text' }
      ]
      /* 表格列配置End */

    };
  },
  computed: {
    pTitle () {
      return this.$route.meta.navtabTitle;
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      qdxxService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          console.log(this.page);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_name, _params) {
      if (_name && (!_params.jzFileId || !_params.brFileId)) {
        this.$message({
          message: '没有现场照片',
          type: 'warning'
        });
        return;
      }
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      qdxxService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    if (this.$route.name === 'wbqdIndex') {
      this.filterParams.qdType = 'XFWBQD';
    } else if (this.$route.name === 'jcqdIndex') {
      this.filterParams.qdType = 'XFJCQD';
    } else if (this.$route.name === 'pgqdIndex') {
      this.filterParams.qdType = 'XFPGQD';
    }
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
